// extracted by mini-css-extract-plugin
export default {"fondo":"Carrito_fondo__LZnX-","caja":"Carrito_caja__f0miu","fondo2":"Carrito_fondo2__fMitr","titulo":"Carrito_titulo__lQ3PM"};